export type PartOfDay = "morning" | "afternoon" | "evening";

export interface Slot {
  time: string; // "HH:mm" Sarajevo wall-clock
  endTime: string;
  booked?: boolean;
}

export interface SlotGroup {
  part: PartOfDay;
  slots: Slot[];
}

const ORDER: PartOfDay[] = ["morning", "afternoon", "evening"];

function partOf(time: string): PartOfDay {
  const hour = parseInt(time.slice(0, 2), 10);
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

/** Group available slots into morning / afternoon / evening, preserving order and dropping empty groups. */
export function groupSlotsByPartOfDay<T extends Slot>(slots: T[]): Array<{ part: PartOfDay; slots: T[] }> {
  const buckets: Record<PartOfDay, T[]> = { morning: [], afternoon: [], evening: [] };
  for (const slot of slots) buckets[partOf(slot.time)].push(slot);
  return ORDER.filter((part) => buckets[part].length > 0).map((part) => ({ part, slots: buckets[part] }));
}
